import { useNavigate } from "react-router";
import { PropsWithChildren, useEffect } from "react";
import {backButton, hapticFeedback} from "@telegram-apps/sdk-react";

function PageWrapper({
                       children,
                       back = true,
                       backPath,
                     }: PropsWithChildren<{
  /**
   * True if it is allowed to go back from this page.
   */
  back?: boolean;
  backPath?: string;
}>) {
  const navigate = useNavigate();

  useEffect(() => {
    if (backButton.isMounted()) {
      if (back) {
        backButton.show();
        return backButton.onClick(() => {
          if (hapticFeedback.impactOccurred.isAvailable()) {
            hapticFeedback.impactOccurred("soft");
          }
          if (backPath) {
            navigate(backPath);
          } else {
            navigate(-1);
          }
        });
      }
      backButton.hide();
    }
  }, [back]);
  return <>{children}</>;
}

export default PageWrapper;
